const locale = {
  APPLICATIONS: 'Aplicação',
  DASHBOARDS: 'Dashboard',
  CALENDAR: 'Calendário',
  ECOMMERCE: 'Loja comercial',
  ACADEMY: 'Cursos',
  MAIL: 'E-mail',
  TASKS: 'Tasks',
  FILE_MANAGER: 'Gerenciar arquivos',
  CONTACTS: 'Contatos',
  CHAT: 'Bate papo',
  SCRUMBOARD: 'Scrumboard',
  NOTES: 'Notas',
};

export default locale;
